<template>
  <div class="room-content">
    1111
  </div>
</template>
<script>
export default {
  name: "pickingTasks",
  components: {},
  data() {
    return {};
  },
  beforeRouteLeave(to, from, next) {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped></style>
